import { ArrowHeadDown, ArrowHeadUp } from "@/assets";
import { Button, FilterCommon, HistoryModal, ImportModal, Table } from "@/components";
import PolicyManagementEmployeeModal from "@/components/PolicyManagement/PolicyManagementEmployeeModal/PolicyManagementEmployeeModal.vue";
import {
  CREATE_TYPE,
  filtersJson,
  getMessageResponseType,
  handleMessagesAPI,
  PAGINATION_DEFAULT,
  policyManagementEmployeeColumns,
  POLICY_MANAGEMENT_EMPLOYEE_SCREEN,
  ROUTER_PAGE_POLICY_CONFIG_CREATE,
  TMS_ROLE_ADMIN,
  TMS_ROLE_HR,
  TMS_ROLE_HRM,
} from "@/utils";
import axios from "axios";
import { mapState } from "vuex";

const actions = [
  {
    key: "history",
    value: "history",
    title: "History",
  },
  {
    key: "edit",
    value: "edit",
    title: "Edit",
  },
  {
    key: "remove",
    value: "remove",
    title: "Remove",
  },
];

const moreFilters = [
  {
    key: "project",
    value: "projectIds",
    label: "Project",
  },
  {
    key: "onboardDate",
    value: "onboardDate",
    label: "Onboard Date Range",
  },
];
export default {
  name: "PolicyManagementEmployee",
  components: {
    FilterCommon,
    Button,
    Table,
    PolicyManagementEmployeeModal,
    ImportModal,
    HistoryModal,
  },
  data() {
    return {
      columns: policyManagementEmployeeColumns,
      POLICY_MANAGEMENT_EMPLOYEE_SCREEN,
      dataFilterDefault: {},
      actions,
      visibleMoreFilter: false,
      ArrowHeadDown,
      ArrowHeadUp,
      filtersJson,
      filterListOrigin: filtersJson[POLICY_MANAGEMENT_EMPLOYEE_SCREEN] ?? [],
      filterList: [],
      moreFilters,
      moreFiltersValueOld: [],
      moreFiltersValue: [],
      visibleModal: false,
      visibleModalImport: false,
      type: null,
      activeRecord: null,
      loadingDownload: false,
      loading: false,
      isApplied: false,
      filter: PAGINATION_DEFAULT,
      source: null,
      timeout: null,
    };
  },
  watch: {
    visibleMoreFilter(newValue) {
      if (newValue && !this.isApplied) {
        this.moreFiltersValue = [...this.moreFiltersValueOld];
      }
    },
    filter() {
      this.getPolicyManagementEmployeeList();
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      policyManagementEmployeeList: (state) => state.policyManagementEmployee.policyManagementEmployeeList,
      pages: (state) => state.policyManagementEmployee.pages,
    }),
    checkShowAction() {
      const {
        userInfo: { roles },
      } = this;
      return roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
    },
  },
  created() {
    this.filterList = this.filterListOrigin.filter((filterItem) => !filterItem.isHide);
  },
  mounted() {
    this.getPolicyManagementEmployeeList();
    window.addEventListener("click", () => {
      this.setVisibleMoreFilter();
    });
  },
  destroyed() {
    window.removeEventListener("click", () => {
      this.setVisibleMoreFilter();
    });
  },
  methods: {
    setVisibleMoreFilter() {
      this.visibleMoreFilter = false;
    },
    async getPolicyManagementEmployeeList() {
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      this.$store.dispatch("user/loadingRequest");
      try {
        await this.$store.dispatch("policyManagementEmployee/getPolicyManagementEmployeeList", this.filter);
      } catch (error) {
        if (!axios.isCancel(error)) {
          // handle error
          handleMessagesAPI(error?.response?.data);
        }
      } finally {
        this.$store.commit("user/RESET_LOADING");
      }
    },
    handleFilter(payload) {
      const { onboardFromDate, onboardToDate } = payload;
      !onboardFromDate && delete this.filter?.onboardFromDate;
      !onboardToDate && delete this.filter?.onboardToDate;
      this.filter = { ...this.filter, ...payload, page: 1 };
    },

    handleAddNew() {
      this.$router.push({ name: ROUTER_PAGE_POLICY_CONFIG_CREATE });
      this.type = CREATE_TYPE;
    },
    handleChangePagination(payload) {
      this.filter = { ...this.filter, ...payload };
    },
    onChangeMoreFilters(checkedValue) {
      this.moreFiltersValue = checkedValue;
      this.isApplied = false;
    },
    handleMoreFilters() {
      this.visibleMoreFilter = !this.visibleMoreFilter;
    },
    handleClearMoreFilter() {
      this.moreFiltersValue = [];
    },
    handleCancelMoreFilters() {
      this.visibleMoreFilter = false;
    },
    handleApplyMoreFilters() {
      this.filterList = this.filterListOrigin.filter(
        ({ isHide, name }) => !isHide || this.moreFiltersValue.includes(name)
      );
      this.moreFiltersValueOld = [...this.moreFiltersValue];
      this.isApplied = true;
    },
    handleSetPolicy() {
      this.type = CREATE_TYPE;
      this.visibleModal = true;
    },
    handleImport() {
      this.visibleModalImport = true;
    },
    async downloadTemplate() {
      this.loadingDownload = true;
      try {
        const res = await this.$store.dispatch("policyManagementEmployee/downloadTemplate");
        handleMessagesAPI(res?.headers);
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        setTimeout(() => {
          this.loadingDownload = false;
        }, 500);
      }
    },
    async onImport(values, onSuccess) {
      try {
        this.loading = true;
        const res = await this.$store.dispatch("policyManagementEmployee/importPolicyManagementEmployee", values);
        handleMessagesAPI(res?.headers);
        const { code } = res?.headers;
        if (code == 200) {
          onSuccess()
          this.getPolicyManagementEmployeeList();
          this.onCancel();
        }
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        this.loading = false;
      }
    },
    onCancel() {
      this.visibleModal = false;
      this.visibleModalImport = false;
      this.type = null;
    },
  },
};
